<script>
export default {
	name: 'MediaCentreListingNewsTile',
	inheritAttrs: false,
};
</script>

<script setup>
import { isMobileViewport } from '~/logic/composables/breakpoints.js';
const props = defineProps({
	date: { type: String, default: '' },
	category: { type: String, default: '' },
	title: { type: String, default: '' },
	path: { type: String, default: '' },
	imageDesktopUrl: { type: String, default: '' },
	imageMobileUrl: { type: String, default: '' },
	imageAltText: { type: String, default: '' },
	size: { type: String, default: 'small' },
	isLargeDesktop: { type: Boolean, default: false },
	componentIdAA: { type: String, default: '' },
});
</script>

<template>

<div
	class="Card"
	:class="{
		'size-small': props.size == 'small',
		'size-largeDesktop': props.size == 'small' && props.isLargeDesktop,
	}"
>
	<AppHyperlink
		v-aa="[
			{
				clickName: props.title,
				clickComponentType: 'URL',
				componentName: 'MediaCentreListing',
				componentID: props.componentIdAA,
			},
			{
				name: props.title,
				type: 'other',
			},
		]"
		class="CardImageWrapper"
		:href="props.path"
	>
		<div
			class="CardImage"
			:style="{
				'background-image': `url(${isMobileViewport ? props.imageMobileUrl : props.imageDesktopUrl})`,
			}"
			:title="props.imageAltText"
		>
			<span class="sr-only">{{ props.imageAltText }}</span>
		</div>
	</AppHyperlink>
	<div class="CardContent">
		<p class="CardLabel">
			{{ props.date }} {{ props.category ? `| ${props.category}` : '' }}
		</p>
		<AppHyperlink
			v-aa="[
				{
					clickName: props.title,
					clickComponentType: 'URL',
					componentName: 'MediaCentreListing',
					componentID: props.componentIdAA,
				},
				{
					name: props.title,
					type: 'other',
				},
			]"
			class="CardTitle"
			:href="props.path"
		>
			<h5
				v-if="(props.size == 'large'
					|| props.size == 'small' && !isMobileViewport && props.isLargeDesktop)"
			>
				{{ props.title }}
			</h5>
			<h6 v-else>{{ props.title }}</h6>
		</AppHyperlink>
	</div>
</div>
</template>



<style scoped lang="scss">
@use 'sass:color';
@use '~/styles/partials/_var.scss';

.Card {
	display: flex;
	flex-direction: column;
	width: 100%;
}
.CardImage {
	padding-top: 66.67%;
	background-image: url('~/assets/batik-pattern-brighter.svg');
	border-radius: 24px;
	background-size: cover;
	background-repeat: no-repeat;
	width: 100%;
	background-position: center center;
}
.CardImageWrapper {
	width: 100%;
	flex-shrink: 0;
}
.CardLabel {
	color: var(--primary-blue-base);
	word-break: break-all;
	text-transform: uppercase;
	@apply font-semibold text-xs line-clamp-2 mt-6 mb-3;
}
.CardTitle {
	color: var(--primary-black-base);
	@apply line-clamp-3 font-semibold;

	&:hover {
		color: var(--primary-blue-light)
	}
}
.size-small {
	display: flex;
	align-items: center;
	flex-direction: row;

	@media #{var.$query-max-lg} {
		align-items: flex-start;
	}
}
.size-small .CardImage {

	@media #{var.$query-max-lg} {
		padding-top: 100%;
		border-radius: 12px;
	}
}
.size-small .CardImageWrapper {
	max-width: 204px;
	@apply mr-6;

	[dir="rtl"] & {
		@apply mr-0 ml-6;
	}

	@media #{var.$query-max-lg} {
		max-width: 74px;
		@apply mr-4;

		[dir="rtl"] & {
			@apply mr-0 ml-4;
		}
	}
}
.size-small .CardLabel {
	@apply mt-0;
}
.size-small.size-largeDesktop {
	display: flex;
	flex-direction: column;
	align-items: flex-start;

	@media #{var.$query-max-lg} {
		flex-direction: row;
	}
}
.size-small.size-largeDesktop .CardImageWrapper {
	max-width: none;
	@apply mr-0;

	@media #{var.$query-max-lg} {
		max-width: 74px;
		@apply mr-4;

		[dir="rtl"] & {
			@apply mr-0 ml-4;
		}
	}
}
.size-small.size-largeDesktop .CardLabel {
	@apply mt-6;
	
	@media #{var.$query-max-lg} {
		@apply mt-0;
	}
}
</style>